// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../../../../types';
import { Tile } from '../../../../tileSelect';

type Props = {
  active: boolean,
  soldOut: boolean,
};

export default styled<typeof Tile, Theme, Props>(Tile)`
  display: flex;
  flex-direction: column;

  ${props => props.active && css`
    color: ${props.theme.configPackage.activeColor};
  `}

  ${props => props.soldOut && css`
    pointer-events: none;
  `}
`;
